import { shorthands, makeStyles, mergeClasses } from "@griffel/react";
import {
  useCommonRibbonButtonStyles,
  getRibbonButtonSizedStyles,
} from "../../next/commonRibbonButtonStyles";
import { RibbonButtonState } from "../../RibbonButton/next";
import { textContainerClassName } from "@1js/acui-common";
import { splitButtonClassNames } from "./useRibbonSplitButtonStyles";

export const useSplitButtonPrimaryButtonRootStyles = makeStyles({
  base: {
    paddingTop: "1px",
    paddingLeft: "9px",
    paddingRight: "2px",
    paddingBottom: "0px",
    ...shorthands.borderRight("0px"),
    minWidth: "20px",
    [`& .${textContainerClassName}`]: {
      paddingLeft: "10px",
      paddingRight: "2px",
    },
  },
  small: {
    paddingLeft: "1px",
    borderRightWidth: "0px",
    [`& .${textContainerClassName}`]: {
      whiteSpace: "nowrap",
      paddingLeft: "4px",
      paddingRight: "0px",
    },
  },
  large: {
    height: "36px",
    minHeight: "36px",
    minWidth: "40px",
    ...shorthands.padding("0px"),
    borderBottomWidth: "0px",
    borderRightWidth: "1px",
    width: "100%",
  },
});

export const useSplitButtonPrimaryButtonIconStyles = makeStyles({
  base: {
    marginTop: "0px",
  },
  large: {
    paddingTop: "2px",
  },
});

export const useRibbonSplitButtonPrimaryButtonStyles = (
  state: RibbonButtonState
) => {
  const rootStyles = useSplitButtonPrimaryButtonRootStyles();
  const iconStyles = useSplitButtonPrimaryButtonIconStyles();

  state.root.className = mergeClasses(
    splitButtonClassNames.primaryActionButton,
    rootStyles.base,
    getRibbonButtonSizedStyles(state.size, rootStyles),
    state.root.className
  );

  if (state.icon) {
    state.icon.className = mergeClasses(
      iconStyles.base,
      getRibbonButtonSizedStyles(state.size, iconStyles),
      state.icon.className
    );
  }
  useCommonRibbonButtonStyles(state as RibbonButtonState);
  return state;
};
